<template>
  <el-dialog
    :visible.sync="visible"
    :before-close="() => this.onClose(false)"
    :show-close="false"
    :close-on-click-modal="false"
    custom-class="agregarProductoDialog"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    :fullscreen="true"
  >
    <span slot="title" :header-style="{ padding: '0px' }">
      <el-row class="headerDialog" style="background-color: var(--main-color);">
        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">{{$t('PRODUCTO_productos')}}</el-col>


        <div v-if="pantallaOrigen == 'PedidoADistribuidor' || pantallaOrigen == 'AltaPedidoSubagente'" >
        <el-col class="carro2" :xs="22" :sm="14" :md="15" :lg="15" :xl="14">
          <span class="notificacion" @click="aceptar">
            <span>
              <transition name="zoomEffect" mode="out-in">
                <div class="iconContainer" :key="cantidad_productos">
                  <i class="el-icon-shopping-cart-2"></i>
                </div>
              </transition>
            </span>
            <span class="badge">{{cantidad_productos}}</span>
          </span>
        </el-col>
        </div>
        

        <div v-else>
          <el-col :xs="20" :sm="12" :md="12" :lg="12" :xl="12" class="total">
          <span>{{$t('PEDIDO_subtotal')}}: {{ decimalToString(this.subtotal) }}</span>
        </el-col>
        <el-col class="carro" :xs="4" :sm="4" :md="4" :lg="4" :xl="3">
          <span class="notificacion" @click="aceptar">
            <span>
              <transition name="zoomEffect" mode="out-in">
                <div class="iconContainer" :key="cantidad_productos">
                  <i class="el-icon-shopping-cart-2"></i>
                </div>
              </transition>
            </span>
            <span class="badge">{{cantidad_productos}}</span>
          </span>
        </el-col>
        </div>

      </el-row>
    </span>

    <!-- Cuerpo -->
    <div>
      <el-row :gutter="20">
        <el-col class="filtroBuscar">
          <el-input
            class="buscador"
            :placeholder="$t('GENERAL_filtrarProductos')"
            prefix-icon="el-icon-search"
            v-model="filtros.filtrar"
            @input="getProductosDelayed"
            clearable
            size="small"
          ></el-input>
        </el-col>
      </el-row>
      <!-- texto que indica la cantidad de productos encontrados mediante los filtros  -->
      <el-collapse-transition >
        <el-row v-if="productos !== undefined" type="flex" justify="center" style="margin-bottom: 5px;">
          <span v-if="loading" class="leyendaCantidadProductos primary" >
            <i class="el-icon-loading"></i>
            {{$t('GENERAL_buscando')}}
          </span>
          <span v-else class="leyendaCantidadProductos">
            {{$t('PRODUCTO_cantidad_encontrados').replace("[cantidad]",productos.length)}}
            {{"(" + $t('GENERAL_cantidadPaginas').replace("[paginaActual]",paginador.page).replace("[totalPagina]", paginador.totalPages).toLowerCase() + ")"}}
          </span>
        </el-row>
      </el-collapse-transition>
      <!-- Filtros -->
      <el-row>
        <el-collapse v-model="collapse">
          <!-- titulo de filtros y tags  -->
          <el-collapse-item name="filtros">
            <template slot="title">
              <el-col :sm="21" :xs="18">
                <el-row>
                  <!-- titulo de pestaña -->
                  <span style="margin-right: 10px;">{{$t('GENERAL_Busqueda_Avanzada')}}</span>
                </el-row>
              </el-col>
              <!-- tag que limpia los filtros aplicados  -->
              <el-col v-if="filtrosAvanzadosSeleccionados.length > 0" :sm="3" :xs="6" style="margin: 5px 5px;" >
                <el-tag :effect="loading ? 'light' : 'dark'" size="mini" 
                  @click="loading ? undefined : cleanFilters()"
                >
                  {{$t('GENERAL_clean_filters')}}
                </el-tag>
              </el-col>
            </template>
            <!-- Filter tab header-->
            <el-col :sm="21" :xs="18">
                <el-row>
                  <!-- titulo de filtros  -->
                  <span style="margin-right: 10px;">{{$t('GENERAL_filtros')}}</span>
                  <!-- tags que muestran los filtros aplicados  -->
                  <el-tag class="hidden-xs-only" v-for="filtroSeleccionado in filtrosAvanzadosSeleccionados" :key="filtroSeleccionado.Id" 
                    size="mini"
                    style="margin-right: 10px;"
                  >
                      {{filtroSeleccionado.DescripcionProducto}}
                  </el-tag>
                </el-row>
            </el-col>
            
            <!-- filtros 1er nivel (equipos o repuestos) -->
            <el-row type="flex" justify="center" style="margin-right: 30px">
              <el-button v-for="filtro in getFiltros1erNivel" :key="filtro.Id" size="mini" :id="filtro.Id"
                class="filterBtn"
                :class="filtrosAvanzadosSeleccionados.find(filtroValor => filtroValor.Id == filtro.Id) ? 'filterBtnChecked' : 'filterBtnUnchecked'"
                :disabled="filtro.disabled"
                @click="aplicarFiltro(filtro)"
              >
                {{filtro.DescripcionProducto}}
              </el-button>
            </el-row>
            <!-- filtros 2do nivel (lineas) -->
            <el-collapse-transition>
            <el-row v-if="getFiltros2doNivel !== undefined && getFiltros2doNivel.length > 0" style="margin-top: 10px;">
              <el-tabs  stretch @tab-click="handleTab" :before-leave="eliminarPropiedades" class="tabsLineas">
                <el-tab-pane v-for="filtro in getFiltros2doNivel" :key="filtro.Id"
                  :name="filtro.DescripcionProducto"
                  :disabled="filtro.disabled"
                >
                  <!-- diseño del label tab -->
                  <template v-slot:label>
                    <el-col>
                      <el-row style="height: 40px;">
                        <el-image :src="filtro.PathImagen" class="imagenDefault"> 
                          <template v-slot:error>
                            <img srcset="../../images/logo.png" class="imagenDefault">
                          </template>
                        </el-image>
                      </el-row>
                      <el-row>
                        {{filtro.DescripcionProducto}}
                      </el-row>
                    </el-col>
                  </template>
                  <!-- contenido del tab -->
                  <el-collapse-transition >
                    <!-- filtros de 3er nivel (propiedades o nuevo nivel) -->
                    <el-row v-if="getFiltros3erNivel !== undefined && getFiltros3erNivel.length > 0 && tabActual == filtro.DescripcionProducto" :gutter="20" style="margin-top: 20px;" >
                      <!-- Si no es un nuevo nivel se listan las propiedades  -->
                      <el-col v-for="filtro2 in getFiltros3erNivel" :key="filtro2.Id" :sm="8" :xs="12" >
                        <!-- label filtro 3er nivel -->
                        <el-divider content-position="left">
                            {{filtro2.DescripcionProducto}}
                        </el-divider>
                        <!-- verifico que se trate de propiedades o un grupo de propiedades  -->
                        <div class="contenido" :id="`${filtro2.Id}`">
                          <!-- lista de propiedades  -->
                          <el-select v-model="filtrosSeleccionadosSelect[filtro2.DescripcionProducto]"  :ref="filtro2.Id" 
                            value-key="PropiedadDescripcion"
                            :placeholder="$t('GENERAL_seleccione')" 
                            v-loading="loadingPropiedades"
                            :loading-text="$t('GENERAL_cargando')"
                            :no-data-text="$t('GENERAL_no_data')"
                            :disabled="filtro.disabled || getPropiedades(filtro2).length === 0"
                            style="margin-bottom: 10px;"
                            filterable
                            clearable
                            @change="aplicarPropiedad($event, filtro2)"
                            @clear="eliminarPropiedadSeleccionada(filtro2.DescripcionProducto)"
                          >
                            <el-option 
                              v-for="(propiedad) in getPropiedades(filtro2)"
                              :key="propiedad.PropiedadDescripcion"
                              :label="propiedad.PropiedadDescripcion"
                              :value="propiedad"
                            >
                            </el-option>
                          </el-select> 
                        </div>
                      </el-col>
                    </el-row>
                    <!-- mensaje que no se encontraron propiedades para mostrar  -->
                    <el-row v-else>
                      <el-row type="flex" justify="center" class="leyendaSinFiltros">
                        <span >{{$t('PRODUCTO_sin_tipo').replace("[tipo]",$t('PRODUCTO_tipo_propiedades'))}}</span>
                      </el-row>
                    </el-row>
                  </el-collapse-transition>
                </el-tab-pane>
              </el-tabs>
            </el-row>
            <!-- mensaje que no se encontraron lineas para mostrar  -->
            <el-row v-else-if="filtrosAvanzadosSeleccionados.length > 0" type="flex" justify="center" class="leyendaSinFiltros">
                <span>{{$t('PRODUCTO_sin_tipo').replace("[tipo]",$t('PRODUCTO_tipo_lineas'))}}</span>
            </el-row>
            </el-collapse-transition>
          </el-collapse-item>
        </el-collapse>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="card_list">
            <div v-if="loading" v-loading.lock="loading" class="loader"></div>
            <div
              v-else-if="productos !== undefined && productos.length > 0"
              class="card_list_item"
              v-for="producto in productos"
              :key="producto.Nombre"
            >
              <ProductoCard
                :producto="producto"
                :pantallaOrigen="pantallaOrigen"
                @agregarProducto="agregarProducto"
                @verDetalleProducto="verDetalleProducto"
              />
            </div>
            <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>
          </div>
        </el-col>
      </el-row>

      <el-row v-if="!loading">
        <el-col :span="24">
          <div class="paginatorContainer">
            <el-pagination
              background
              layout="prev, pager, next"
              hide-on-single-page
              :page-size="paginador.pageSize"
              :page-count="paginador.totalPages"
              :current-page="paginador.page"
              :pager-count="5"
              @current-change="onPageChange"
            />
          </div>
        </el-col>
      </el-row>
    </div>
    <DetalleProductoDialog
      :visible="innerVisible"
      :onClose="onCloseCancelar"
      :producto="this.detalleProducto"
      append-to-body
    />

    <span slot="footer" class="dialog-footer">
      <el-row>
        <el-col :xs="12" :sm="20" :md="20" :lg="20" :xl="20">
          <el-button type="primary" @click="aceptar">{{ confirmBtn || $t('GENERAL_acceptBtn') }}</el-button>
        </el-col>
        <el-col :xs="12" :sm="4" :md="4" :lg="4" :xl="4">
          <el-button @click="cancelar">{{ cancelBtn || $t('GENERAL_cancelBtn') }}</el-button>
        </el-col>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import ProductoCard from "@/components/Cards/productoCard";
import { decimalToString } from "../Helpers/commonFunctions";
import DetalleProductoDialog from "../Dialog/detalleProducto";

export default {
  name: "AgregarProductoDialog",
  components: { ProductoCard, DetalleProductoDialog },
  props: {
    visible: Boolean,
    cancelBtn: String,
    confirmBtn: String,
    onClose: Function,
    productosAgregados: Array,
    detallesAgregados: Array,
    subtotal: Number,
    pantallaOrigen: String,
  },
  data() {
    return {
      tabActual: undefined,
      limpiarDatosProductos: false,
      productosSeleccionadosTemporal: [],
      productoAgregado: false,
      agregar_producto_msg: "",
      estado_msg: "",
      producto: undefined,
      innerVisible: false,
      detalleProducto: undefined,
      loading: false,

      // PRODUCTOS CARGADOS
      productos: undefined,
      paginador: { page: 1, pageSize: 20, totalPages: 1 },

      //VARIABLE PARA REALIZAR EL FILTRADO
      filtros: {
        filtrar: "",
        ordenar: undefined,
        linea: undefined,
        subFiltros: undefined,
        equipo: false,
        repuesto: false
      },

      productoAux: undefined,

      playZoomAnimation: false,

      // VARIABLES PARA BUSQUEDA AVANZADA
      filtrosAvanzadosSeleccionados: [],
      loadingPropiedades: false,
      filtrosSeleccionadosSelect: {},
      ultimoFiltro3erNivelAplicado: undefined,
      selectActual: undefined,
      collapse: undefined
    };
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      filtrosAvanzados: state => state.productos.filtrosBusquedaAvanzada,
    }),

    cantidad_productos: function() {
      if (this.pantallaOrigen == 'Presupuesto') {
        return (
          this.productosAgregados.length +
          this.productosSeleccionadosTemporal.length +
          this.detallesAgregados.length
        );
      }
      else {
        return (
          this.productosAgregados.length +
          this.productosSeleccionadosTemporal.length
        );
      }
    },
    getFiltros1erNivel()
    {
      return this.filtrosAvanzados.filter(filtro => filtro.Nivel == 1);
    },
    getFiltros2doNivel()
    {
      // se obtienen los filtros de segundo nivel pero que correspondan a los hijos del filtro de primer nivel seleccionado
      if(this.filtrosAvanzadosSeleccionados.length > 0)
        return this.getHijosFiltro(this.filtrosAvanzadosSeleccionados[0]);
      else
        return undefined;
    },
    getFiltros3erNivel()
    {
      // se obtienen los filtros de tercer nivel pero que correspondan a los hijos del filtro de segundo nivel seleccionado
      if(this.filtrosAvanzadosSeleccionados.length > 1)
      {
        let filtros3erNivel = undefined;
        let filtro2doNivelSeleccionado = this.filtrosAvanzadosSeleccionados[1];
        // debo evaluar si los filtros de 3er nivel son propiedades o representan un nuevo nivel (B1)
        let indexPadre = this.filtrosAvanzados.findIndex(filtro => filtro.Id == filtro2doNivelSeleccionado.Id);
        let primerHijo = this.filtrosAvanzados[indexPadre + 1] // los hijos estan continuos al padre
        if(primerHijo.Accion == 'B1')
        {
          // obtengo el limite hasta donde debo realizar la busqueda. Es decir, el proximo filtro de segundo nivel.
          let proximoFiltro2doNivel = this.filtrosAvanzados.filter(filtro => filtro.Orden > filtro2doNivelSeleccionado.Orden && filtro.Nivel == 2)[0];
          filtros3erNivel = this.filtrosAvanzados.filter(filtro => filtro.Accion == "B1" && filtro.Orden < proximoFiltro2doNivel.Orden);
        }
        else
        {
          let longitudFiltrosSeleccionados = this.filtrosAvanzadosSeleccionados.length;
          // las propiedades siempre van a corresponder al ultimo filtro de 2do nivel seleccionado (linea)
          filtros3erNivel = this.getHijosFiltro(this.filtrosAvanzadosSeleccionados[longitudFiltrosSeleccionados - 1]);
        }
        return filtros3erNivel;
      }
      else
        return undefined
    },
    getFiltros4toNivel()
    {
      // un filtro de 3er nivel puede ser un listado de propiedades o grupo de propiedades
      if(this.filtrosAvanzadosSeleccionados.length > 1)
      {
        let filtros3erNivel = this.getFiltros3erNivel;
        
        let filtros4toNivel = [];
        filtros3erNivel.forEach(filtro => {
          let hijos = this.getHijosFiltro(filtro);
          filtros4toNivel.push(...hijos);
        });
        return filtros4toNivel;
      }
        // return this.getHijosFiltro(this.filtrosAvanzadosSeleccionados[this.filtrosAvanzadosSeleccionados.length - 1])
      else
        return undefined
    },
    getPropiedades()
    {
      return filtro => {
        if(filtro.Propiedades)
        {
          let propiedadesDisponibles = filtro.Propiedades.filter(x => !x.disabled && x.PropiedadDescripcion !== "");
          return propiedadesDisponibles
        }
        else
          return []
      }

    },
  },
  watch:
  {
    collapse(newVal, oldVal)
    {
      if(newVal.length > 0 && this.filtrosAvanzadosSeleccionados.length == 0)
        this.aplicarFiltro(this.filtrosAvanzados[0]);
    }
  },
  methods: {
    decimalToString: decimalToString,
    handleTab(tab)
    {
      
      let filtro = this.filtrosAvanzados.find(x => x.DescripcionProducto == tab.name);
      if(filtro)
        this.aplicarFiltro(filtro);
    },
    eliminarPropiedades(pestaniaActual, pestaniaAnterior)
    {
        this.tabActual = pestaniaActual;
        if(this.filtrosAvanzadosSeleccionados.length > 1)
        {
          let filtro = this.filtrosAvanzados.find(x => x.DescripcionProducto == pestaniaAnterior);
          if(filtro)
          {
            let filtros3erNivel = this.getHijosFiltro(this.filtrosAvanzadosSeleccionados[1]);
            filtros3erNivel.map(filtro => filtro.Propiedades = undefined);
          }
          
        }
       
    },
    aplicarFiltro(filtroSeleccionado)
    {     
      // saco el focus del boton para que no quede bindeado el estilo al evento click si es que se trata de un boton
      let button = document.getElementById(filtroSeleccionado.Id);
      if(button !== null)
        button.blur();
      
      this.clearSelects();
        this.paginador.page = 1;
        this.paginador.pageSize = 20;
        this.paginador.totalPages = 1;
        this.productos = undefined;
      // si es un filtro del primer nivel se deben eliminar todos los filtros seleccionados ya que se estaria cambiando de opcion o deshabilitando todos los filtros hijos
      if(filtroSeleccionado.Nivel == 1)
      { // TODO: ELIMINAR ESTE CODIGO COMENTADO CUANDO SE ELIMINE EL NUEVO NIVEL AGREGADO Y SE TESTEE
        // this.eliminarPropiedadSeleccionada();
        // this.clearSelects();
        this.filtrosAvanzadosSeleccionados = [];
        // this.paginador.page = 1;
        // this.paginador.pageSize = 20;
        // this.paginador.totalPages = 1;
        // this.productos = undefined;
      }
      else
      {
        
        // si es un filtro de segundo nivel o tercer nivel se deben pedir las propiedades de los hijos si es que ya no se tienen.
        // los hijos estan continuos al padre 
        let indexHijoFiltroSeleccionado = this.filtrosAvanzados.findIndex(filtro => filtro.Id == filtroSeleccionado.Id) + 1;
        // Si el primer hijo del filtro seleccionado es de tipo C y no tiene propiedades se deben pedirlas
        if(this.filtrosAvanzados[indexHijoFiltroSeleccionado].Accion == "C")
        {
          if(!this.filtrosAvanzados[indexHijoFiltroSeleccionado].Propiedades)
          {
            // armo el payload
            let payload = {
              idUsuario: this.idUsuario,
              clave_descripcion: this.filtros.filtrar,
              pantallaOrigen: this.pantallaOrigen,
              nodo: filtroSeleccionado.Id,
              filtros: [],
              page: this.paginador.page,
              pageSize: this.paginador.pageSize
            };
            // pido las propiedades de la linea seleccionada (filtro 2do nivel)
            this.loadingPropiedades = true;
            this.$store.dispatch('productos/getProductos', payload).then((data) => {

              if (data.CodigoResultado === 0) 
              {
                let paginado = JSON.parse(data.Datos);
                // guardo temporalmente las propiedades
                let propiedadesDisponibles = paginado.Result[0].Propiedades;
                // agrupo las propiedades por ID
                var propiedadesAgrupadas = propiedadesDisponibles.reduce(function (r, a) {
                        r[a.PropiedadId] = r[a.PropiedadId] || [];
                        r[a.PropiedadId].push(a);
                        return r;
                }, Object.create(null));
              
                // se obtienen todos los hijos del filtro seleccionado
                let hijosNodo = this.getHijosFiltro(filtroSeleccionado);
                // obtengo los nombres de las propiedades agrupadas
                let nombresPropiedades = Object.keys(propiedadesAgrupadas);
                // en cada hijo se deben guardar cada grupo de propiedades segun corresponda
                nombresPropiedades.forEach(nombrePropiedad => {
                  
                  // seteo las propiedades en el hijo
                  let hijo = hijosNodo.find(hijo => hijo.PropiedadId == parseInt(nombrePropiedad));
                  if(hijo)
                    hijo.Propiedades = propiedadesAgrupadas[nombrePropiedad];
                })
              }
            })
            .finally(() => this.loadingPropiedades = false)
          }
        }
        
        this.filtrosSeleccionadosSelect = {};
        
        // si hay un filtro con el mismo nivel del que se quiere agregar es porque se realizo un cambio de filtro.
        // Se deben eliminar los hijos del filtro que se encontraba aplicado
        let indexFiltroAplicado = this.filtrosAvanzadosSeleccionados.findIndex(filtro => filtro.Nivel == filtroSeleccionado.Nivel);
        if(indexFiltroAplicado != -1)
        {
          this.eliminarFiltroAvanzadoSeleccionado(this.filtrosAvanzadosSeleccionados[indexFiltroAplicado]);
        }
      }
      
      // si no fue aplicado lo agrego a la lista
      this.filtrosAvanzadosSeleccionados.push(filtroSeleccionado);
    },
    aplicarPropiedad(propiedad, filtro3erNivelAplicado)
    {
      if(propiedad)
      {
        this.ultimoFiltro3erNivelAplicado = filtro3erNivelAplicado;
        this.paginador.page = 1;
        // obtengo los productos y la nueva lista de propiedades disponibles
        this.getProductos();
      }

    },
    clearSelects()
    {
      // se activan los selects y sus propiedades
      if(this.getFiltros3erNivel !== undefined)
        // Se valida que los filtros de 3er nivel tengan propiedades dado que estas se piden recien cuando el usuario
        // cambio de tab. Con lo cual se puede querer realizar un 'clearSelects' antes que la respuesta llegue del back
        if(this.getFiltros3erNivel.every(filtro3erNivel => filtro3erNivel.Propiedades !== undefined))
        {
          this.getFiltros3erNivel.forEach(filtro3erNivel => {
              filtro3erNivel.disabled = false;
              filtro3erNivel.Propiedades.map(propiedad => propiedad.disabled = false);
          });
        }
          
      
    },
    deshabilitarPropiedades(propiedadesDisponibles)
    {
      // por cada uno de los filtros de 3er nivel se debe verificar si las propiedades siguen estando disponibles.
      // No se deben deshabilitar las propiedades del ultimo filtro seleccionado
      this.getFiltros3erNivel.filter(x => x.Id !== this.ultimoFiltro3erNivelAplicado.Id).forEach(filtro3erNivel => {
        let propiedadesDeshabilitadas = 0;

        // se recorren las propiedades de cada filtro para verificar si se encuentra en la lista de propiedades disponibles
        filtro3erNivel.Propiedades.forEach(propiedad => {
          let prop = {
            PropiedadId: propiedad.PropiedadId,
            PropiedadValor: propiedad.PropiedadValor,
            PropiedadDescripcion: propiedad.PropiedadDescripcion
          }
          let propiedadDisponible = propiedadesDisponibles.find(propDisponible => JSON.stringify(propDisponible) === JSON.stringify(prop));
          // si la propiedad no se encuentra disponible se desactiva la opcion del select
          if(!propiedadDisponible)
          {
            propiedad.disabled = true;
            propiedadesDeshabilitadas++;
          }
          else
            propiedad.disabled = false;
        })

        // si todas las propiedades de un select se encuentran deshabilitadas entonces se deshabilita el select
        if(propiedadesDeshabilitadas == filtro3erNivel.Propiedades.length)
          filtro3erNivel.disabled = true;
        else
          filtro3erNivel.disabled = false;
      })
      
    },
    deshabilitarFiltros(habilitar)
    {
      this.getFiltros1erNivel.map(filtro => filtro.disabled = habilitar);

      if(this.getFiltros2doNivel !== undefined)
        this.getFiltros2doNivel.map(filtro => filtro.disabled = habilitar);

      if(this.getFiltros3erNivel !== undefined)
        this.getFiltros3erNivel.map(filtro => filtro.disabled = habilitar);

    },
    eliminarFiltroAvanzadoSeleccionado(filtro)
    {
      
      // obtengo el index del filtro seleccionado a eliminar
      var index = this.filtrosAvanzadosSeleccionados.findIndex(filtroSeleccionado => filtroSeleccionado.Id == filtro.Id);
      if(index !== -1)
      {
        // elimino el filtro de la lista de seleccionados
        this.filtrosAvanzadosSeleccionados.splice(index,1);
        // se obtienen los hijos del filtro si es que tiene
        let hijos = this.getHijosFiltro(filtro);
        
        if(hijos.length > 0)
        {
          // Si tiene hijos se deben obtener a su vez los hijos de los hijos de forma recursiva para poder eliminarlos
          hijos.forEach(hijo => {
            this.eliminarFiltroAvanzadoSeleccionado(hijo);
          })
        }
      }
    },
    eliminarPropiedadSeleccionada(propiedad)
    {
      // obtengo los valores seleccionados de los select si es que existen
      let valores = Object.values(this.filtrosSeleccionadosSelect);
      // si sigue habiendo propiedades seleccionadas se deben pedir nuevamente los productos y las propiedades disponibles.
      // caso contrario se limpian los selects y se setean las opciones al estado por default
      if(valores.some(valor => valor !== "" && valor !== undefined))
        this.getProductos();
      else
        this.clearSelects();

      if(this.filtros.filtrar !== "")
        this.getProductos();
      else
      {
        this.paginador.page = 1;
        this.paginador.pageSize = 20;
        this.paginador.totalPages = 1;
        this.productos = undefined;
      }
    },
    getHijosFiltro(filtro)
    {
      let hijos = [];
      //obtengo el index del primer hijo si es que tiene. El hijo si existe se encontrara continuo al padre
      let index = this.filtrosAvanzados.findIndex(filtroAvanzado => filtroAvanzado.Id == filtro.Id) + 1;
      // obtengo el nivel del filtro
      let nivelFiltro = filtro.Nivel
      
      switch(filtro.Nivel)
      {
        case 1:
          //obtengo el siguiente filtro de nivel 1
          let siguienteFiltro1erNivel = this.filtrosAvanzados.filter(x => x.Nivel == 1 && x.Id !== filtro.Id)[0];
          // se obtienen todos los filtros de nivel 2 y que se encuentren en un orden entre el filtro de 1er nivel seleccionado y el siguiente filtro de 1er nivel
          hijos = this.filtrosAvanzados.filter(filtroAvanzado => (filtroAvanzado.Nivel == 2 && filtroAvanzado.Orden > filtro.Orden && filtroAvanzado.Orden < siguienteFiltro1erNivel.Orden));
          break;
        case 2: case 3:
          // mientras se trate de un filtro con nivel igual al nivel siguiente del filtro seleccionado es porque se trata de un hijo
          while ((this.filtrosAvanzados[index].Nivel == (nivelFiltro + 1 )) && (index < this.filtrosAvanzados.length)) 
          {
            hijos.push(this.filtrosAvanzados[index]);
            index = index + 1;
          }
          break;

      }
      
      return hijos;
    },
    handleClose(done) {
      this.$confirm(this.agregar_producto_msg).then(() => {
        done(this.agregarProductos(this.producto));
      });
    },
    open(mensaje) {
      if (this.productoAux.EstadoVenta == "B") {
        this.$confirm(mensaje, this.$t("GENERAL_atencion"), {
          confirmButtonText: this.$t("GENERAL_agregar_continuar"),
          cancelButtonText: this.$t("GENERAL_cancelBtn"),
          type: "warning"
        }).then(() => {
          this.producto = this.productoAux;
          this.buscarProductoRepetido(this.producto);
        });
      } else
        this.$alert(mensaje, this.$t("PRODUCTO_agregar_producto_error"), {
          confirmButtonText: this.$t("GENERAL_cancelBtn"),
          type: "error"
        });
    },

    getProductosDelayed() {
      this.paginador.page = 1;

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.getProductos();
      }, 1000);
    },

    getProductos() {
      let filtrosAvanzados = [];
      Object.values(this.filtrosSeleccionadosSelect).forEach(filtroSeleccionado => {
      if(filtroSeleccionado !== "" && filtroSeleccionado !== undefined && filtroSeleccionado.PropiedadDescripcion !== "")
        filtrosAvanzados.push(filtroSeleccionado)
      });
      // No se busca hasta que no se ingresa un filtro
      if (this.filtros.filtrar == "" && filtrosAvanzados.length == 0)
      {
        this.cleanFilters();
        return
      }

      // indico que se están buscando los Productos
      this.loading = true;
      this.loadingPropiedades =true;

      // armo el payload
      let payload = {
        idUsuario: this.idUsuario,
        clave_descripcion: this.filtros.filtrar,
        pantallaOrigen: this.pantallaOrigen,
        page: this.paginador.page,
        pageSize: this.paginador.pageSize
      };

      // si le paso una propiedad es porque requiero la busqueda avanzada
      if(filtrosAvanzados.length > 0)
      {
        payload.nodo = this.filtrosAvanzadosSeleccionados[1].Id;
        payload.filtros = filtrosAvanzados ;
      }
      // deshabilito los selects para evitar busquedas de productos recurrentes
      this.deshabilitarFiltros(true);
      
      this.$store
        .dispatch("productos/getProductos", payload)
        .then(data => {
          
          if (data.CodigoResultado === 0) {
            // habilito los selects
            this.deshabilitarFiltros(false);

            let paginado = JSON.parse(data.Datos);
            this.paginador.totalPages = paginado.TotalPages;
            // guardo los productos
            this.productos = paginado.Result[0].Productos;
            // si se utilizo la busqueda avanzada se deben deshabilitar las propiedades que dejen de estar disponibles debido a la seleccion
            if(paginado.Result[0].Propiedades.length > 0 && payload.nodo)
              this.deshabilitarPropiedades(paginado.Result[0].Propiedades);
          }
          else
            this.deshabilitarFiltros(false);
        })
        //.finally(() => (this.loading = false));
       .finally(() => {
         this.loading = false;
         this.loadingPropiedades= false;
       })
    },

    verDetalleProducto(producto) {
      this.detalleProducto = producto;
      this.innerVisible = true;
    },

    buscarProductoRepetido(producto) {
      let mensaje = this.$t("PRODUCTO_agregar_repetido_mensaje");
      mensaje = mensaje.replace("[codigo]", producto.Nombre);
      this.agregar_producto_msg = mensaje;

      this.productosAgregados.forEach(element => {
        if (element.Nombre === producto.Nombre) {
          this.handleClose();
          return (this.productoAgregado = true);
        }
      });

      this.productosSeleccionadosTemporal.forEach(element => {
        if (element.Nombre === producto.Nombre) {
          this.handleClose();
          return (this.productoAgregado = true);
        }
      });

      if (!this.productoAgregado) {
        this.agregarProductos(producto);
      }
    },

    agregarProducto(producto) {
      //this.producto = producto;
      //this.buscarProductoRepetido(producto);
      this.estadoVenta(producto);
    },

    estadoVenta(producto) {
      let mensaje = this.$t("PRODUCTO_estado");
      this.productoAux = producto;
      switch (producto.EstadoVenta) {
        case "A":
          this.producto = this.productoAux;
          this.buscarProductoRepetido(producto);
          break;

        case "B":
          if(producto.Leyenda !=""){
          mensaje = mensaje.replace("[leyenda]", producto.Leyenda);
          this.estado_msg = mensaje;
          this.open(mensaje);
          }
          else{
            this.producto = this.productoAux;
            this.buscarProductoRepetido(producto);
          }
          break;

        case "C":
          mensaje = mensaje.replace("[leyenda]", producto.Leyenda);
          this.estado_msg = mensaje;
          this.open(mensaje);
          break;

        default:
          this.producto = this.productoAux;
          this.buscarProductoRepetido(producto);
          break;
      }
    },

    agregarProductos(producto) {
      this.productoAgregado = false;
      this.agregar_producto_msg = "";
      this.productosSeleccionadosTemporal.push(producto);
      this.calcularImporte(producto);
      this.confirmacion = false;
    },

    onCloseCancelar() {
      this.innerVisible = false;
    },
    aceptar() {
      this.$emit(
        "agregarProductosSeleccionados",
        this.productosSeleccionadosTemporal
      );
      this.onClose(false);
      this.cleanFilters();
      this.productosSeleccionadosTemporal = [];
    },

    cancelar() {
      this.limpiarDatosProductos = true;
      this.productosSeleccionadosTemporal = [];
      this.onClose(false);
      this.cleanFilters();
    },

    calcularImporte(producto) {
      if(this.pantallaOrigen == "Presupuesto" && producto.ManoObraChecked == true){
        this.subtotal += producto.Cantidad * (producto.Precio + producto.ManoObra);
      }else{
        this.subtotal += producto.Cantidad * producto.Precio;
      }
      
    },

    cleanFilters() {
      // limpio los filtros
      this.filtros = {
        filtrar: "",
      };
      
      // elimino las propiedades seleccionadas
      this.filtrosSeleccionadosSelect = {};
      // se limpian los selects
      this.clearSelects();
      // elimino los filtros seleccionados
      this.eliminarFiltroAvanzadoSeleccionado(this.filtrosAvanzadosSeleccionados[0]);
      this.paginador.page = 1;
      this.paginador.pageSize = 20;
      this.paginador.totalPages = 1;

      // limpio los resultados de los productos
      this.productos = undefined;

      //this.getProductos();
    },

    onPageChange(newPage) {
      this.paginador.page = newPage;
      this.getProductos();
    }
  },
  created()
  {
    if(this.filtrosAvanzados.length == 0)
      this.$store.dispatch('productos/getJerarquiaProductos');
  },
  mounted() {
    //Scroll para Android
    document.body.scrollTop = 0;
    //Scroll para IOS
    document.documentElement.scrollTop = 0;

  },

  destroyed() {
    this.productosSeleccionadosTemporal = [];
  },

};
</script>

<style scoped>
div.el-select {
  width: 100%;
}
.filterBtn {
  padding: 6px 10px !important;
}
.leyendaSinFiltros
{
  margin-top: 10px; 
  color: #999;
}
.filterBtnChecked {
  background-color: var(--main-color); 
  color: white;
}

.filterBtnUnchecked {
  background-color: white; 
  color: #606266;
}

.el-button-group .filterBtn {
  padding: 12px 10px !important; 
  margin-right: 10px;
  margin-bottom: 10px;
}

.imagenDefault {
  max-width: 3em;
  height: auto;
  max-height: 40px;
}
.loader {
  padding: 25% 0;
  color: #999;
  text-align: center;
}
.el-dialog {
  width: 85% !important;
}
.el-dialog__body {
  word-break: break-word;
  padding: 0px !important;
}
.filtro {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}
.filtros {
  display: flex;
  align-content: space-between;
  margin-bottom: 20px;
}
.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}
.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  /*grid-template-rows: repeat(auto-fit, minmax(100px, 1fr));*/
  grid-gap: 1rem;
}

.card_list_item {
  position: relative;
}

.iconContainer {
  font-size: 25px;
  cursor: pointer;
}
.notificacion {
  color: black;
  text-decoration: none;
  position: relative;
  display: inline-block;
  border-radius: 2px;
}

.carro {
  text-align: center;
}

.carro2 {
  text-align: right;
}

.notificacion .badge {
  cursor: pointer;
  position: absolute;
  top: -10px;
  right: -25px;
  padding: 2px 8px;
  border-radius: 50%;
  background: var(--main-color);
  color: white;
}

.notificacion .badge:hover {
  background-color: white;
  color: var(--main-color);
}

.el-dialog__footer button {
  text-align: center;
}

.btnContainer {
  display: flex;
}

.botonFiltro {
  background: white;
  color: var(--main-color);
  border-color: var(--main-color);
  padding: 0px;
}

.el-input-number {
  background: black;
}

.total {
  padding-right: 20px;
  text-align: right;
}
.contenido {
  border-style: solid;
  border-color: #DCDFE6;
  border-width: 1px;
  border-top: none;
  padding: 10px;
  padding-bottom: 0px;
  margin: 0px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  margin-bottom: 20px;
}
.el-divider {
  margin: 0px;
  padding: 0px;
}
.el-divider__text {
  font-size: 12px;
  font-weight: bold;
  color:var(--main-color);
  padding: 0 5px;
}
.leyendaCantidadProductos{
  color: gray;
  font-size: 11px;
}
@media (max-width: 650px) {
  .el-dialog__title {
    font-size: 16px !important;
  }
  .carro {
    text-align: left;
  }
  .total {
    padding-right: 20px;
    text-align: left;
  }
}

@media (max-width: 360px) {
  .el-dialog__footer button {
    width: 100%;
  }
}
</style>

<style>
.tabsLineas .el-tabs__nav
{
  height: 80px;
}
.tabsLineas .el-tabs__nav-prev, .tabsLineas .el-tabs__nav-next
{
  color:var(--main-color);
  font-weight: bold;
  margin-top: 20px;
}
.filtros.hidden-sm-and-down .btnContainer .botonFiltro {
  padding: 0px 10px !important;
}
.filtros.hidden-md-and-up .btnContainer .botonFiltro {
  padding: 5px 2px !important;
}
.filtros .el-select {
  padding: 0 10px;
  width: 70%;
}

.filtroBuscar {
  text-align: center;
  background: #ffffff;
}
.buscador {
  margin-bottom: 10px;
}
.buscador .el-input__inner {
  border-radius: 40px;
}
.filtros.hidden-md-and-up .buscador {
  margin-bottom: 10px;
}

.el-dialog.is-fullscreen.agregarProductoDialog {
  max-width: 1200px;
  width: 90%;
  height: calc(100% - 50px);
  margin-top: 25px;
  overflow: hidden;
}
.agregarProductoDialog .el-dialog__header {
  background-color: var(--main-color);
  color: #ffffff;
  font-size: 1.5em;
  font-weight: bold;
  padding: 10px 0 10px 20px;
}
.agregarProductoDialog .el-dialog__body {
  overflow-y: auto;
  height: calc(100% - 140px);
  padding: 10px 20px;
}

.el-button:focus {
  background: var(--main-color);
  color: white;
}

.paginatorContainer {
  margin-top: 25px;
  text-align: right;
}

@media (max-width: 500px) {
  .agregarProductoDialog {
    width: 100%;
  }
  .el-dialog.is-fullscreen.agregarProductoDialog {
    width: 100%;
    height: 100%;
    margin-top: 0px;
    overflow: hidden;
  }
  .agregarProductoDialog .el-dialog__body {
    overflow-y: auto;
    height: calc(100% - 160px);
    padding: 10px 20px;
  }
}

.zoomEffect-enter-active {
  animation: zoomAnimation 0.8s;
}

@keyframes zoomAnimation {
  0% {
    transform: scale(4);
    opacity: 0.25;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>